export const STUDENT_ASSIGNMENT_VIEW_LOAD_REQUEST = 'STUDENT_ASSIGNMENT_VIEW_LOAD_REQUEST';
export const STUDENT_ASSIGNMENT_VIEW_LOAD_SUCCESS = 'STUDENT_ASSIGNMENT_VIEW_LOAD_SUCCESS';
export const STUDENT_ASSIGNMENT_VIEW_LOAD_FAILURE = 'STUDENT_ASSIGNMENT_VIEW_LOAD_FAILURE';
